import { ru } from './ru_RU'
import { he } from './he_IL'
import { en } from './en_US'

export type TLang = 'ru' | 'he' | 'en'
export type TTranslations = typeof ru

export const t: TTranslations = Object.assign({}, ru)

export const setLocale = (locale: string) => Object.assign(t, ({
  ru, he, en
})[locale.split('-')[0].toLowerCase()]);
